import { createTextualBlockKeyHandler } from '@lumapps/wrex-textual-block/utils/createTextualBlockKeyHandler';

import { isCodeBlock } from '../../utils/isCodeBlock';

/**
 * Initialize the key event handler for the code block editor:
 * - 'Enter' inside a code block inserts a line break (shared textual-block behavior).
 * - 'ArrowUp'/'ArrowLeft' on a leading code block inserts a paragraph above it.
 */
export const getKeyHandler = createTextualBlockKeyHandler(isCodeBlock);
